<template>
    <FormModel
            :action="submit" :labelCol="{span:4}" :model="form"
            :rules="rules" :wrapperCol="{span: 20}" style="width: 560px;">
        <a-form-model-item label="是否启用" prop="available">
            <a-radio-group v-model="form.available">
                <a-radio :value="true">开启</a-radio>
                <a-radio :value="false">停用</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="详情内容" prop="content">
            <TinymceEditor v-model="form.content"/>
        </a-form-model-item>
    </FormModel>
</template>

<script>
   import api from "../../../../utils/api";
   import FormModel from "../../../../comps/FormModel";
   import TinymceEditor from "../../../../comps/TinymceEditor";

   export default {
      name: "Intro",
      props: {album: Object},
      components: {TinymceEditor, FormModel},
      data() {
         return {
            form: {
               content: "",
               available: true,
            },
            rules: {
               content: {required: true, message: "详情内容不能为空"}
            },
         }
      },
      mounted() {
         this.load();
      },
      methods: {
         load() {
            const self = this;
            api.v1.album.intro.get(this.album.id)
               .then(res => {
                  if (res.id) self.form = res.info
               });
         },
         submit() {
            return api.v1.album.intro.set(this.album.id, this.form);
         }
      }
   }
</script>

<style scoped>

</style>